// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1u4tU","footer":"styles_footer__rGYGy","passCodeTooltip":"styles_passCodeTooltip__2pJJp"};